/*
 * Kerzam · Auftrag 05c (30.09.2026): Duftnoten-Bild auf Geräten ohne Maus.
 * Nur Startseite: eingebunden in sections/featured-collection.liquid (nur template index), mit defer.
 * Ablauf: Kachel zu mindestens 60 % sichtbar → 0,8 s warten → in 0,6 s zum zweiten Bild überblenden
 * → 2,5 s halten → zurück zur Flasche. Einmal pro Erscheinen, keine Endlosschleife.
 * Das Autoplay des Sliders wartet so lange und rückt danach eine Kachel weiter (Entscheidung Hamza, 30.09.).
 * Tippen und Wischen bleiben unverändert: keine Touch-, Klick- oder Hover-Handler, kein :hover.
 * Nicht bei prefers-reduced-motion: reduce, nicht auf Geräten mit Maus. Ohne jQuery, ohne Bibliothek.
 * Nachtrag 09b (06.10.2026): Im Raster „Unsere beliebtesten Düfte“ sind bis zu 4 Kacheln gleichzeitig sichtbar. Damit nicht alle
 * auf einmal wechseln, startet jede weitere Kachel 0,25 s später (in der Reihenfolge im Dokument: 0,8 / 1,05 / 1,3 / 1,55 s).
 * Ohne Slider bleibt der Autoplay-Teil wirkungslos.
 * Auftrag 10 (06.10.2026): Nach dem Überblenden bleibt das bunte Bild stehen (kein Halten, kein Zurück), einmal je Kachel,
 * auch nach Weg- und Zurückscrollen. Zusätzlich eingebunden im Kollektionsraster (sections/main-collection-product-grid.liquid);
 * nachgeladene Karten (Endlos-Scrollen, Filter) erfasst der MutationObserver.
 */
(function () {
  'use strict';
  if (window.kerzamTouchHover) return; // Abschnitt kann mehrfach eingebunden sein: nur einmal starten
  window.kerzamTouchHover = true;
  if (!window.matchMedia || !('IntersectionObserver' in window) || !('WeakSet' in window)) return;

  var mqHover = window.matchMedia('(hover: none)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!mqHover.matches || mqReduce.matches) return;

  var WAIT = 800, FADE = 600, HOLD = 2500, LOAD_MAX = 3000, RATIO = 0.6, STAGGER = 250;
  var ROOT = 'kerzam-touch-hover', ON = 'kerzam-th-on';
  // Dreifache Klasse: höhere Spezifität als die Regeln in responsive.css (bis 0,6,0 mit !important),
  // auch wenn nach einem Tippen :hover hängen bleibt (iOS).
  var R3 = '.' + ROOT + '.' + ROOT + '.' + ROOT;

  var style = document.createElement('style');
  style.id = 'kerzam-touch-hover-css';
  style.textContent = '@media (hover: none) and (prefers-reduced-motion: no-preference){' +
    R3 + ' .product-image img.hongo-alternate-image{transition:opacity .6s ease,transform 1.1s cubic-bezier(.15,.75,.5,1)}' +
    R3 + ' .product-image.' + ON + '.' + ON + ' img.hongo-alternate-image{opacity:1!important;transform:translateZ(0)}' +
    '}';
  document.head.appendChild(style);

  var seen = new WeakSet();
  var bunt = new WeakSet(); // Auftrag 10: Kacheln, die schon ins bunte Bild gewechselt sind, bleiben so
  var nextSlot = 0; // frühester Start der nächsten Überblendung (Versatz zwischen gleichzeitig sichtbaren Kacheln)
  var io = new IntersectionObserver(function (entries) {
    var due = [];
    entries.forEach(function (e) {
      if (e.isIntersecting && e.intersectionRatio >= RATIO) due.push(e.target);
      else reset(e.target);
    });
    due.sort(function (a, b) { return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1; });
    due.forEach(start);
  }, { threshold: [0, RATIO] });

  function allowed() { return mqHover.matches && !mqReduce.matches; }

  function swiperOf(tile) {
    var el = tile.closest('.swiper');
    return el && el.swiper && el.swiper.autoplay ? el.swiper : null;
  }

  // Autoplay je Slider anhalten, solange mindestens eine Kachel ihren Ablauf zeigt
  function hold(tile) {
    var sw = swiperOf(tile);
    if (!sw) return;
    sw.kerzamThCount = (sw.kerzamThCount || 0) + 1;
    if (sw.kerzamThCount === 1 && sw.autoplay.running) {
      sw.autoplay.stop();
      sw.kerzamThStopped = true;
    }
  }

  function release(tile, next) {
    var sw = swiperOf(tile);
    if (!sw || !sw.kerzamThCount) return;
    sw.kerzamThCount -= 1;
    if (sw.kerzamThCount === 0 && sw.kerzamThStopped) {
      sw.kerzamThStopped = false;
      if (sw.destroyed) return;
      if (next) sw.slideNext();
      sw.autoplay.start();
    }
  }

  function loaded(img, done, fail) {
    if (img.complete && img.naturalWidth > 0) { done(); return; }
    var t = setTimeout(fail, LOAD_MAX);
    img.addEventListener('load', function () { clearTimeout(t); if (img.naturalWidth > 0) done(); else fail(); }, { once: true });
    img.addEventListener('error', function () { clearTimeout(t); fail(); }, { once: true });
  }

  function start(tile) {
    if (bunt.has(tile) || tile.kerzamTh || !allowed()) return; // schon bunt, läuft schon oder in diesem Erscheinen schon gezeigt
    var alt = tile.querySelector('img.hongo-alternate-image');
    if (!alt) return; // kein zweites Bild: nichts tun
    var now = Date.now();
    var at = Math.max(now + WAIT, nextSlot);
    nextSlot = at + STAGGER;
    var run = { stage: 'warten' };
    tile.kerzamTh = run;
    hold(tile);
    run.t1 = setTimeout(function () {
      loaded(alt, function () {
        if (tile.kerzamTh !== run) return;
        tile.classList.add(ON);
        bunt.add(tile); // Auftrag 10: bleibt bunt
        run.stage = 'fertig';
        io.unobserve(tile);
        run.t2 = setTimeout(function () { release(tile, true); }, FADE);
      }, function () {
        if (tile.kerzamTh !== run) return; // Bild lädt nicht: nichts zeigen, Autoplay freigeben
        run.stage = 'fertig';
        release(tile, false);
      });
    }, at - now);
  }

  function reset(tile) {
    var run = tile.kerzamTh;
    if (!run || bunt.has(tile)) return;
    clearTimeout(run.t1); clearTimeout(run.t2); clearTimeout(run.t3);
    tile.classList.remove(ON);
    tile.kerzamTh = null; // beim nächsten Erscheinen wieder
    if (run.stage !== 'fertig') release(tile, false);
  }

  function scan(root) {
    root.querySelectorAll('.product-box .product-image').forEach(function (tile) {
      if (seen.has(tile)) return;
      seen.add(tile);
      if (!bunt.has(tile)) tile.classList.remove(ON); // Kopien von Swiper (Loop) können die Klasse mitbringen
      tile.kerzamTh = null;
      if (tile.querySelector('img.hongo-alternate-image')) io.observe(tile);
    });
  }

  function init() {
    document.querySelectorAll('script[data-kerzam-touch-hover]').forEach(function (s) {
      var root = document.getElementById(s.getAttribute('data-kerzam-touch-hover'));
      if (!root || root.classList.contains(ROOT)) return;
      root.classList.add(ROOT);
      scan(root);
      if ('MutationObserver' in window) {
        new MutationObserver(function () { scan(root); }).observe(root, { childList: true, subtree: true });
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
